import React, { Component } from 'react'
import firebase from "../config/firebase"
import FileUploader from "react-firebase-file-uploader"
import SweetAlert from 'react-bootstrap-sweetalert'
import logo from '../assets/img/logo.jpg';
// import VideoThumbnail from 'react-video-thumbnail'; // use npm published version
import API from '../config/API'
import _ from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons'

export default class Upload extends Component {
    constructor(props) {
        super(props)
        this.SweetAlert = React.createRef();
        this.state = {
            username: "",
            avatar: "",
            isUploading: false,
            progress: 0,
            avatarURL: "",
            // avatarURL: 'https://firebasestorage.googleapis.com/v0/b/wiwer-881f8.appspot.com/o/images%2Fa4269170-7ff3-494e-aaf2-ca10f8e9aae0.jpeg?alt=media&token=61a9a2ad-ac9d-4c5e-8b7e-c57fd0623176',
            question: '',
            answers: {},
            correct: 'A',
            checkCorr: ['A', 'B', 'C', 'D'],
            videoId: '',
            logoImage: '',
            alert: null,
            videos: [],
            brandName: '',
            videoName: ''
        }
    }

    componentDidMount() {
        this.getData();
    }

    checkAnswers = () => {
        const {
            answers,
        } = this.state;
        if (answers.A && answers.B && answers.C && answers.D) {
            if (answers.A.trim() !== ''
                && answers.B.trim() !== ''
                && answers.C.trim() !== ''
                && answers.D.trim() !== '') {
                return true;
            }
        }
        return false;
    };

    validate = (e) => {
        e.preventDefault();
        const {
            avatarURL,
            question,
            answers,
            correct,
            checkCorr,
            videoId,
            logoImage,
            brandName, videoName
        } = this.state;
        let valid = true;
        let msg = '';
        if (avatarURL === '') {
            valid = false;
            msg = 'Please enter video link';
        } else if (videoId.trim() === '') {
            valid = false;
            msg = 'Please enter valid youtube video link';
        } else if (question.trim() === '') {
            valid = false;
            msg = 'Please enter question';
        } else if (!this.checkAnswers()) {
            valid = false;
            msg = 'Please enter all answers';
        } else if (checkCorr.indexOf(correct) < 0) {
            valid = false;
            msg = 'Please enter one of A/B/C/D (in capital)';
        } else if (logoImage === '') {
            valid = false;
            msg = 'Please upload logo image';
        } else if (brandName.trim() === '') {
            valid = false;
            msg = 'Please enter Sponser Name';
        }
        else if (videoName.trim() === '') {
            valid = false;
            msg = 'Please enter Video Name';
        }

        if (valid) {
            this.writeUserData({
                videoId,
                videoUrl: avatarURL,
                question: question,
                answers,
                correct: correct,
                logoImage,
                brandName: brandName,
                videoName: videoName
            });
        } else {
            // alert(msg);
            this.setState({
                alert: { danger: true, title: msg, children: [], onConfirm: this.onConfirm, onCancel: this.onCancel }
            });
        }
    };

    getVideoId = () => {
        let url = this.state.avatarURL;
        var ID = '';
        url = url.replace(/(>|<)/gi, '').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
        if (url[2] !== undefined) {
            ID = url[2].split(/[^0-9a-z_\-]/i);
            ID = ID[0];
        }
        else {
            ID = url;
        }
        this.setState({ videoId: ID });
        return ID;
    };

    writeUserData = (data) => {
        // let ref = API.quizzes();
        // ref.set(data);
        firebase.database().ref('quizzes').push(data);
        // alert('DATA SAVED');
        this.setState({
            alert: { success: true, title: 'DATA SAVED', children: [], onConfirm: this.onConfirm, onCancel: this.onCancel }
        });
    }

    getData = () => {
        firebase.database().ref('/quizzes').on('value', snapshot => {
            const state = snapshot.val();
            let ary = [];
            // eslint-disable-next-line array-callback-return
            Object.keys(state).map((key) => {
                let obj = {
                    id: key,
                    ...state[key],
                };
                ary.push(obj);
            })
            this.setState({ videos: ary });
            // this.videos = ary;
        });
    }

    handleChange = (key) => event => {
        this.setState({ [key]: event.target.value }, () => {
            if (key === 'avatarURL') {
                this.getVideoId();
            }
        });
    }

    handleChangeAnswer = (key) => event => {
        let answers = this.state.answers;
        answers[key] = event.target.value
        this.setState({ answers });
    }

    handleUploadStart = () => {
        this.setState({ isUploading: true, progress: 0 });
    }

    handleProgress = progress => {
        this.setState({ progress });
    }

    handleUploadError = error => {
        this.setState({ isUploading: false });
        console.error(error);
    };

    handleUploadSuccess = async filename => {
        try {
            this.setState({ avatar: filename, progress: 100, isUploading: false });
            const url = await firebase.storage().ref("video").child(filename).getDownloadURL();
            console.log(url);
            this.setState({ logoImage: url });
        } catch (error) {
            console.log(error);
        }
    };

    onConfirm = () => {
        console.log('onConfirm');
        if (this.SweetAlert) {
            //   this.SweetAlert.hideAlert();
            this.setState({ alert: null });
            console.log(this.SweetAlert);
        }
    };

    onCancel = () => {
        console.log('onCancel');
        if (this.SweetAlert) {
            // this.SweetAlert.hideAlert();
            this.setState({ alert: null });
            console.log(this.SweetAlert);
        }
    };

    askRemoveVideo = (video) => {
        this.setState({
            alert: {
                warning: true,
                showCancel: true,
                confirmBtnText: "Yes",
                confirmBtnBsStyle: "danger",
                title: 'Are you sure ? you want to delete video ?',
                children: [],
                onConfirm: () => {
                    this.onConfirm();
                    this.removeVideo(video);
                },
                onCancel: this.onCancel
            }
        });
    };

    removeVideo = async (video) => {
        firebase.database().ref(`/quizzes/${video.id}`).remove(this.onDeleted);
    };

    onDeleted = () => {
        this.setState({
            alert: {
                success: true,
                title: 'Video deleted successfully',
                children: [],
                onConfirm: this.onConfirm,
                onCancel: this.onCancel
            }
        });
    };

    renderAlert = () => {
        const { alert } = this.state;
        if (!alert) {
            return null;
        }
        return (
            <SweetAlert {...alert} ref={(o) => { this.SweetAlert = o; }}>
                {alert.children}
            </SweetAlert>
        );
    };

    render() {
        const {
            logoImage,
            progress,
            isUploading,
            avatarURL,
            question,
            correct,
            answers,
            videos,
            brandName,
            videoName
        } = this.state;
        return (
            <div className="upload-page py-4">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 mx-auto">

                            <img src={logo} className="d-block mx-auto" alt={'logo'} height="150" />
                            <h5 className="card-title text-center"><b>Welcome to Wiwer Admin</b></h5>

                            <nav>
                                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                    <a className="nav-item nav-link active" id="nav-home-tab" data-toggle="tab" href="#upload" role="tab" aria-controls="nav-home" aria-selected="true">Upload Video</a>
                                    <a className="nav-item nav-link" id="nav-profile-tab" data-toggle="tab" href="#list" role="tab" aria-controls="nav-profile" aria-selected="false">List of Videos</a>
                                </div>
                            </nav>
                            <div className="tab-content" id="nav-tabContent">


                                <div className="tab-pane fade show active" id="upload" role="tabpanel" aria-labelledby="nav-home-tab">
                                    <form className="form-upload" onSubmit={this.validate}>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="logo">Upload Logo</label>
                                                    {/* <input type="file" id="logo" className="d-block" /> */}
                                                    <FileUploader
                                                        accept="image/*"
                                                        name="avatar"
                                                        className="d-block"
                                                        randomizeFilename
                                                        storageRef={firebase.storage().ref("video")}
                                                        onUploadStart={this.handleUploadStart}
                                                        onUploadError={this.handleUploadError}
                                                        onUploadSuccess={this.handleUploadSuccess}
                                                        onProgress={this.handleProgress}
                                                    />
                                                    <div className="img-preview">
                                                        {isUploading && <p>Progress: {progress}</p>}
                                                        {logoImage && <img className="img-preview" alt="preview" src={logoImage} />}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Youtube Link</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={avatarURL || ''}
                                                        onChange={this.handleChange('avatarURL')}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Brand Name</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={brandName || ''}
                                                        onChange={this.handleChange('brandName')}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Video Name</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={videoName || ''}
                                                        onChange={this.handleChange('videoName')}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Question</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={question || ''}
                                                        onChange={this.handleChange('question')}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Answer (A)</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={answers.A || ''}
                                                        onChange={this.handleChangeAnswer('A')}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Answer (B)</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={answers.B || ''}
                                                        onChange={this.handleChangeAnswer('B')}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Answer (C)</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={answers.C || ''}
                                                        onChange={this.handleChangeAnswer('C')}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Answer (D)</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={answers.D || ''}
                                                        onChange={this.handleChangeAnswer('D')}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Correct Answer</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={correct || ''}
                                                        onChange={this.handleChange('correct')}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <hr className="my-4" />
                                        <div className="mx-auto text-center">
                                            <button className="btn text-uppercase" type="submit">Submit</button>
                                        </div>
                                    </form>
                                </div>

                                <div className="tab-pane fade" id="list" role="tabpanel" aria-labelledby="nav-profile-tab">
                                    <div className="main-data">
                                        <div className="table-responsive">
                                            <table className="table table-striped">
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th width="10%">Thumbnail</th>
                                                        <th>Youtube Link</th>
                                                        <th width="10%">Likes</th>
                                                        <th width="10%">Dislikes</th>
                                                        <th width="5%" align="center" ></th>
                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    {videos.map((video, index) => {
                                                        const likes = _.isArray(video.likeUsers) ? video.likeUsers.length : 0;
                                                        const dislikes = _.isArray(video.dislikeUsers) ? video.dislikeUsers.length : 0;
                                                        return (
                                                            <tr key={`row_${index}`}>
                                                                <td>{index + 1}</td>
                                                                <td>
                                                                    <div className="y-thumb">
                                                                        <img src={`https://img.youtube.com/vi/${video.videoId}/default.jpg`} alt="logo" />
                                                                    </div>
                                                                </td>
                                                                <td><a target="_blank" rel="noopener noreferrer" href={`https://www.youtube.com/watch?v=${video.videoId}`}>{`https://www.youtube.com/watch?v=${video.videoId}`}</a></td>
                                                                <td>{likes}</td>
                                                                <td>{dislikes}</td>
                                                                <td className="text-center">
                                                                    <div style={{ cursor: 'pointer' }} onClick={() => this.askRemoveVideo(video)}>
                                                                        <FontAwesomeIcon icon={faTrash} />
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                    {/* <tr>
                                                <td>1</td>
                                                <td><div className="y-thumb"><img src={logo} alt="logo" /></div></td>
                                                <td>https://www.youtube.com/</td>
                                                <td>123</td>
                                                <td>23</td>
                                                <td className="text-center"><div><i className="fas fa-trash"></i></div></td>
                                            </tr>
                                            <tr>
                                                <td>2</td>
                                                <td><div className="y-thumb"><img src={logo} alt="logo" /></div></td>
                                                <td>https://www.youtube.com/</td>
                                                <td>123</td>
                                                <td>23</td>
                                                <td className="text-center"><div><i className="fas fa-trash"></i></div></td>
                                            </tr>
                                            <tr>
                                                <td>3</td>
                                                <td><div className="y-thumb"><img src={logo} alt="logo" /></div></td>
                                                <td>https://www.youtube.com/</td>
                                                <td>123</td>
                                                <td>23</td>
                                                <td className="text-center"><div><i className="fas fa-trash"></i></div></td>
                                            </tr>
                                            <tr>
                                                <td>4</td>
                                                <td><div className="y-thumb"><img src={logo} alt="logo" /></div></td>
                                                <td>https://www.youtube.com/</td>
                                                <td>123</td>
                                                <td>23</td>
                                                <td className="text-center"><div><i className="fas fa-trash"></i></div></td>
                                            </tr>
                                            <tr>
                                                <td>5</td>
                                                <td>
                                                    <div className="y-thumb">
                                                        <img src={logo} alt="logo" />
                                                    </div>
                                                </td>
                                                <td>https://www.youtube.com/</td>
                                                <td>123</td>
                                                <td>23</td>
                                                <td className="text-center"><div><i className="fas fa-trash"></i></div></td>
                                            </tr> */}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    <hr className="my-4" />
                                    <div className="mx-auto text-center">
                                        <button className="btn text-uppercase" type="submit">Submit</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.renderAlert()}
            </div>
        );
    }
}
